import { render, staticRenderFns } from "./workspaces_dropdown_group.vue?vue&type=template&id=12af613e&vue3"
import script from "./workspaces_dropdown_group.vue?vue&type=script&lang=js&vue3"
export * from "./workspaces_dropdown_group.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports